import { PRIVATE_API } from './index';
const endpoints = {
    gameTasks: '/tasks',
    gameState: '/game-sessions/status',
    gameComplete: '/game-sessions/complete',
    taskAnswersTimeLogsList: '/task-time-logs',
    taskAnswer: '/player-answer',
    taskAnswersList: '/player-answers',
};
export const getGameTasks = async () => {
    return await PRIVATE_API.GET.all({ endpoint: endpoints.gameTasks });
};
export const getGameState = async () => {
    return await PRIVATE_API.GET.single({ endpoint: endpoints.gameState });
};
export const sendTaskAnswersTimeLogsList = async (body) => {
    return await PRIVATE_API.POST({ endpoint: endpoints.taskAnswersTimeLogsList, body });
};
export const sendTaskAnswer = async (body) => {
    return await PRIVATE_API.POST({ endpoint: endpoints.taskAnswer, body });
};
export const sendTaskAnswersList = async (body) => {
    return await PRIVATE_API.POST({ endpoint: endpoints.taskAnswersList, body });
};
export const sendCompleteGame = async (body) => {
    return await PRIVATE_API.POST({ endpoint: endpoints.gameComplete, body });
};
